// Modules
import React, { useState } from 'react'
import { Body, Button, Flex, Input, InputPassword, Spacing } from '@dasa-health/alma-react'
import { useForm, Controller } from 'react-hook-form'
import { Calendar } from '@dasa-health/alma-icons'

// Components
import { InputStringNumber } from 'redesign/components/molecules/InputStringNumber'
import { Form } from './styles'

// Applications
import { yupResolver } from '@hookform/resolvers/yup'
import { schemaValidationCipAndFap } from 'redesign/validators/cipAndFap'
import { maskBirthDate } from 'utils'
import { FormInputs, useSelfServiceCip } from 'redesign/hooks/useSelfServiceCip'
import { getFieldError } from 'redesign/utils/form'
import { useSelfServiceCPF } from 'redesign/hooks/useSelfServiceCPF'

export function LoginSelfServiceCipAndFap() {
    const { control, handleSubmit, setError, formState } = useForm<FormInputs>({
        resolver: yupResolver(schemaValidationCipAndFap),
        mode: 'onBlur',
        defaultValues: {
            birthDate: '',
            cipAndFap: '',
            password: '',
        },
    })

    const [isSubmitting, setIsSubmitting] = useState(false)
    const { handleLoginWithCipAndFap } = useSelfServiceCip()
    const { changePage } = useSelfServiceCPF()

    const onSubmit = ({ birthDate, cipAndFap, password }: FormInputs) =>
        handleLoginWithCipAndFap({ birthDate, cipAndFap, password, setError, setIsSubmitting })

    return (
        <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Flex flexDirection="column" justifyContent="flex-start" width="100%">
                <Body variant="lg">Para acessar, informe os dados que constam no protocolo que você recebeu ao fazer seu exame.</Body>
                <Spacing height={24} />
                <InputStringNumber control={control} label="Número da CIP ou FAP" name="cipAndFap" />
                <Spacing height={24} />

                <Controller
                    control={control}
                    name="password"
                    render={({ field, fieldState }) => (
                        <InputPassword
                            autoComplete="off"
                            label="Senha"
                            readOnly={isSubmitting}
                            {...field}
                            width="100%"
                            {...getFieldError(fieldState, formState)}
                        />
                    )}
                />

                <Spacing height={24} />

                <Controller
                    control={control}
                    name="birthDate"
                    render={({ field, fieldState }) => (
                        <Input
                            {...field}
                            autoComplete="off"
                            label="Data de nascimento"
                            onChange={e => field.onChange(maskBirthDate(e.target.value))}
                            readOnly={isSubmitting}
                            trailingIcon={<Calendar color="#161616E0" />}
                            type="text"
                            width="100%"
                            {...getFieldError(fieldState, formState)}
                        />
                    )}
                />

                <Spacing height={24} />

                <Button disabled={isSubmitting} isLoading={isSubmitting} type="submit" width="100%">
                    Continuar
                </Button>

                <Spacing height={24} />

                <Button onClick={changePage} variant="secondary">
                    Acessar com o CPF
                </Button>
                <Spacing height={24} />
            </Flex>
        </Form>
    )
}
